import { render } from "./ProductDescriptionEntryDetails.vue?vue&type=template&id=4c3fffe2&scoped=true&ts=true"
import script from "./ProductDescriptionEntryDetails.vue?vue&type=script&lang=ts"
export * from "./ProductDescriptionEntryDetails.vue?vue&type=script&lang=ts"

import "./ProductDescriptionEntryDetails.vue?vue&type=style&index=0&id=4c3fffe2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3fffe2"]])

export default __exports__